import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    marginTop: 40,
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    height: 60,
  },
  ImageLogin: {
    width: 82,
    height: 140,
    resizeMode: 'contain',
    marginTop: 50,
    marginBottom: 50,
  },
});
